var render = function render(){var _vm=this,_c=_vm._self._c;return _c('messages-area',{attrs:{"api":_vm.api,"profile":"customer"}})
}
var staticRenderFns = []

export { render, staticRenderFns }